<template>
  <simple-table
    :rows="rows"
    :columns="columns"
    :equal-width="equalWidth"
    empty-message="No access logs to display"
    @sort="handleSort"
  />
</template>

<script>
import { axios, parseDate } from '@qlik-trial/automations-ui'
import format from 'date-fns/format'

export default {
  props: ['accountGuid'],

  data() {
    return {
      logs: [],
      columns: [
        {
          id: 'time',
          label: 'Time',
          sortable: true,
          sorted: 'desc',
        },
        {
          id: 'user',
          label: 'User',
        },
      ],
    }
  },

  computed: {
    rows() {
      const rows = this.logs.map(log => {
        return {
          id: log.guid,
          time: parseDate(log.created_at),
          user: log.impersonator.name,
          comment: log.comment,
        }
      })

      const isAsc = this.columns.find(column => column.id === 'time').sorted === 'asc'

      rows.sort((a, b) => isAsc ? a.time - b.time : b.time - a.time)

      return rows.map(row => {
        return { ...row, time: format(row.time, 'd LLL yyyy HH:mm:ss') }
      })
    },

    equalWidth() {
      return this.columns.length === 2
    },
  },

  created() {
    axios.get(`/accounts/${this.accountGuid}/impersonation-logs`)
      .then(response => {
        this.logs = response.data.data

        if (this.logs.some(log => 'comment' in log)) {
          this.columns.push({ id: 'comment', label: 'Comment', emptyLabel: 'No comment' })
        }
      })
  },

  methods: {
    handleSort(event) {
      const column = this.columns.find(col => col.id === event.id)
      column.sorted = event.sorted
    },
  },
}
</script>
